<!-- 
    * 期望进球： homeColor: rgba(230, 52, 84, 1); awayColor: rgba(101, 199, 199, 1)
 -->

<template>
  <div
    class="player_averageOccupancy_scatter"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <div class="horizontal_box">
      <div :class="isBorder ? 'echartsBorder' : ''" class="echartsBg">
        <div
          id="chartDom"
          ref="chartDom"
          :style="{ height: chartDomHPx }"
          @click.stop="downLoad($refs.chartDom, true)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
// 球员平均占位
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'coordinateSystemScatter',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isBorder: {
      //演播室要球场和边界区域一起的，所以不要边，比例是2000/1340=1.49，约等于1.5
      type: Boolean,
      default: false,
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      homeBgColor: 'rgba(235, 27, 80, 1)', //主队：【覆盖色】
      awayBgColor: 'rgba(0, 207, 183, 1)', //客队：【覆盖色】
      otherColor: 'rgba(255,255,255,1)', //[覆盖色上面的字体颜色]
      initFlag: false,
      myChart: null,
      homeData: [],
      awayData: [],
      chartDomHPx: 'auto',
      combatObj: [
        {
          logo: 'https://images.mixtmt.com/img-euro/teams/TUR/TUR_240x240.png',
          name: '俄罗斯',
          id: '1',
        },
        {
          logo: 'https://images.mixtmt.com/img-euro/teams/TUR/TUR_240x240.png',
          name: '美国',
          id: '2',
        },
      ],
    }
  },
  created() {
    if (this.currThemeObj && this.currThemeObj.cssStyle) {
      const cssStyle = this.currThemeObj.cssStyle
      this.homeBgColor = cssStyle.echarts_keyEventBar_homeColor
      this.awayBgColor = cssStyle.echarts_keyEventBar_awayColor
      this.otherColor = cssStyle.echarts_keyEventBar_otherColor_1
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchartFlag()
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
  },
  components: {},
  watch: {
    datas(val) {
      if (this.initFlag && this.myChart) {
        this.initdata(val.data.dataList)
        this.initEcharts()
      }
    },
  },
  methods: {
    initEchartFlag() {
      setTimeout(() => {
        if (this.$refs.chartDom && this.$refs.chartDom.clientWidth) {
          this.chartDomHPx = `${Math.ceil(
            this.$refs.chartDom.clientWidth / 1.5
          )}px`
          this.symbolSize = Math.floor(this.$refs.chartDom.clientWidth * 0.056)
          console.debug('this.symbolSize:', this.symbolSize)
          this.$nextTick(() => {
            this.initdata(this.datas.data.dataList)
            // this.initdata(dataList) //测试数据入口
            this.initFlag = true
            this.initEcharts()
            // this.myChart.on('click', 'series.line', (params) => {
            //   console.debug(params)
            //   if (params.componentType == 'markPoint') {
            //     // 点击了 markPoint
            //     this.isMarkFlag = true
            //   }
            // })
          })
        } else {
          this.initEchartFlag()
        }
      }, 50)
    },
    initdata(dataList) {
      // dataList = [[{ averageX: 59, averageY: 51, shirtNumber: 9 }]]
      const allPlayerData = []
      dataList.forEach((item, index) => {
        let homeAway = ''
        if (index == 0) {
          homeAway = 'HOME'
        }
        if (index == 1) {
          homeAway = 'AWAY'
        }
        item.forEach((point) => {
          allPlayerData.push({
            name: `${homeAway}_${point.shirtNumber}`,
            value: [point.averageX, point.averageY, point.shirtNumber],
            symbol: 'circle',
            symbolSize: this.symbolSize,
            // symbolOffset: [0, 0],
            label: {
              show: true,
              formatter: '{@[2]}',
              fontWeight: 'bold',
              fontFamily: 'Qatar2022',
              fontSize: Math.floor(this.symbolSize * 0.667),
              lineHeight: this.symbolSize,
              widht: this.symbolSize,
              height: this.symbolSize,
              color: this.otherColor,
            },
            itemStyle: {
              color: homeAway == 'HOME' ? this.homeBgColor : this.awayBgColor,
              opacity: 1,
            },
          })
        })
        this.allPlayerData = allPlayerData
      })
    },
    clickEchartBox(e) {
      console.debug(e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      // 2000/1340
      const dom = this.$refs.chartDom

      let option = {
        title: {
          show: false,
          text: '球员平均占位',
        },
        tooltip: {
          show: false,
          trigger: 'axis',
        },
        grid: {
          top: `0`,
          bottm: `0`,
          left: '1.4%',
          right: '1.4%',
          width: '97.2%',
          height: `100%`,
        },
        // dataZoom: {
        //   show: true,
        //   type: 'inside',
        //   zoomLock: true,
        // },
        legend: {
          show: false,
        },
        xAxis: {
          // type: 'category',
          boundaryGap: false,
          max: 100,
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          boundaryGap: false,
          max: 100,
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            data: this.allPlayerData,
            type: 'scatter',
          },
        ],
      }
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      this.myChart.setOption(option)

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.chartDom, true, 'uploadData')
        }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.player_averageOccupancy_scatter {
  width: 65%; //59%
  &.autoExportPng {
    width: 100%;
    .horizontal_box {
      border: 0;
      background: transparent;
      border-radius: 0;
    }
  }
  .horizontal_box {
    border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
    background: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.694vw;
  }
  .echartsBg {
    background-color: var(--mixtmt_echarts_footBallPlaygroundBgColor);
  }
}
/* 描边演播室不要，因此网页也不需要，这里的颜色暂不用抽离 */
.echartsBorder {
  border: 0.416vw solid #eaedf1;
  background: #eaedf1;
  border-radius: 0.694vw;
}
#chartDom {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  background-image: var(--mixtmt_ball_bg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
  // border:6px solid #EAEDF1;
  // border-radius: 14px;
  // box-sizing: content-box;
}
#chartDom {
  width: 100%;
  height: 100%;
  transform: rotateX(0deg);
}
</style>
